"use client";

import { useEffect, useState } from 'react';
import { getRecommendedModels } from '@/app/utilities/apis';
import RecommendedCarItem from '@/component/ui/RecommendedCarItem';
import { EMICALCULATOR_POPUP_TRACKING } from '@/lib/constants/tracking';

interface RecommendedCarsSectionProps {
    brandSlug: string;
    modelSlug: string;
}

export default function RecommendedCarsSection({ brandSlug, modelSlug }: RecommendedCarsSectionProps) {
    const [cars, setCars] = useState<any[]>([]);

    useEffect(() => {
        let mounted = true;
        getRecommendedModels(brandSlug, modelSlug)
            .then((res: any) => {
                const raw: any[] = Array.isArray(res?.data) ? res.data : [];
                if (mounted) {
                    setCars(raw.slice(0, 5).map((m: any) => ({
                        id: m._id?.toString?.() ?? String(m._id),
                        brand_id: m.brand_id,
                        brand_name: m.brand_name,
                        brand_slug: m.brand_slug,
                        model_name: m.name,
                        model_slug: m.slug,
                        price_range: { base: m.price_range?.base ?? null, top: m.price_range?.top ?? null },
                        image: m.featured_image,
                    })));
                }
            })
            .catch(() => {});
        return () => { mounted = false; };
    }, [brandSlug, modelSlug]);

    if (!cars.length) return null;

    return (
        <div className="bg-white border border-gray-200 rounded-lg p-4">
            <h2 className="text-sm font-semibold text-gray-800 mb-2">Recommended Cars</h2>
            <div className="divide-y divide-gray-100">
                {cars.map((car, index) => (
                    <RecommendedCarItem
                        key={car.id ?? index}
                        car={car}
                        isLast={index === cars.length - 1}
                        showEmiLink={false}
                        trackingClass={EMICALCULATOR_POPUP_TRACKING.RECOMMENDED_CAR_CLICK}
                    />
                ))}
            </div>
        </div>
    );
}
